import {GeospatialService} from '../../helper/geospatial-service';
import {AssetFieldsService} from '../../fields/asset-fields.service';
import {Injectable} from '@angular/core';
import {AssetPolygonRendererService} from '../../renderers/asset-polygon-renderer.service';
import Graphic from '@arcgis/core/Graphic';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import Polygon from '@arcgis/core/geometry/Polygon';
import {SpatialEntityDataExtended} from '@core/utils/engin/geospatial-viewer/helper/engin-data-prepare.service';
import {GenericPopupService} from '@core/utils/engin/geospatial-viewer/popups/generic-popup.service';
import {GeoJSONGeometryType} from '../../../../../../pages/geospatial-viewer/model/api';
import {VisualizationType} from '../../../../../../pages/geospatial-viewer/model/visualization';

@Injectable()
export class PolygonLayerService {
    constructor(
        private geospatialService: GeospatialService,
        private genericPopupService: GenericPopupService,
        private rendererService: AssetPolygonRendererService,
        private fieldsService: AssetFieldsService,
    ) {}

    _preparePolygonSettings = {
        popupTemplate: true,
        metrics: [],
        mapType: null,
    };

    /**
     * Create polygon layer for asset population
     * @return FeatureLayer
     */
    public preparePolygonLayer(
        polygonData: SpatialEntityDataExtended[],
        renderedVisualizationType: VisualizationType,
        id: string,
        theme: string,
        settings: any = this._preparePolygonSettings,
    ): FeatureLayer {
        const polygonSource: Graphic[] = this.createPolygonGraphics(polygonData);

        let polygonPopupTemplate = null;
        if (settings?.popupTemplate) {
            polygonPopupTemplate = {
                title: '{id}',
                outFields: ['*'],
                content: this.genericPopupService.getGenericMetricTooltipFunction.bind(
                    this.genericPopupService,
                    settings?.metrics || [],
                    renderedVisualizationType,
                ),
            };
        }

        return new FeatureLayer({
            id: id ? id : 'asset_polygon_layer',
            objectIdField: 'ObjectID',
            source: polygonSource,
            renderer: this.rendererService.layerRenderer(theme),
            fields: this.fieldsService.getMapFields(),
            outFields: ['*'],
            popupTemplate: polygonPopupTemplate,
        });
    }

    /*
     * Create array of Graphics, type = point. Return Graphic[]
     */
    private createPolygonGraphics(areaData: SpatialEntityDataExtended[]): Graphic[] {
        return areaData.map((area: SpatialEntityDataExtended) => {
            // ArcGIS API for Javascript takes number[][][], so need to flatten the outer layer
            if (area.geoJsonGeometry.type == GeoJSONGeometryType.MultiPolygon) {
                return new Graphic({
                    geometry: new Polygon({
                        rings: [].concat.apply([], area.geoJsonGeometry.coordinates as number[][][][]),
                    }),
                    attributes: {...area},
                });
            }
            return new Graphic({
                geometry: new Polygon({
                    rings: area.geoJsonGeometry.coordinates,
                }),
                attributes: {...area},
            });
        });
    }
}
